module.exports = __webpack_public_path__ + "assets/img/help_image01-2.a212226f.png";